/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KioskMaintenanceDto } from '../../models/kiosk-maintenance-dto';

export interface MaintenanceCheckKioskMaintenance$Params {
  kioskId?: string;
}

export function maintenanceCheckKioskMaintenance(http: HttpClient, rootUrl: string, params?: MaintenanceCheckKioskMaintenance$Params, context?: HttpContext): Observable<StrictHttpResponse<KioskMaintenanceDto>> {
  const rb = new RequestBuilder(rootUrl, maintenanceCheckKioskMaintenance.PATH, 'get');
  if (params) {
    rb.query('kioskId', params.kioskId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KioskMaintenanceDto>;
    })
  );
}

maintenanceCheckKioskMaintenance.PATH = '/v1/Maintenance/CheckKioskMaintenance';
